import { DeliverableStatus, IDeliverable } from "models/IProjectIQWorkspace";
import { CustomOption } from "components/fields/peoplePicker/PeoplePicker.types";

export interface IDeliverableFormDialogProps {
  isOpen: boolean;
  deliverable: IDeliverable | null;
  workspaceId: string;
  onDismiss: (saved: boolean) => void;
}

export interface IFormValues {
  name: string;
  description: string;
  dueDate: string;
  status: DeliverableStatus;
  owner: CustomOption | null;
  reviewer: CustomOption | null;
}

export const DEFAULT_FORM_VALUES: IFormValues = {
  name: "",
  description: "",
  dueDate: "",
  status: "not_started",
  owner: null,
  reviewer: null,
};
